import { type Page } from '#shared/api/schema';
import { useExperimentCartPreview, useExperimentFlag } from '#shared/lib/flags';
import { CONSTRUCTOR_ACCOUNT_REFUNDS_ALIAS, CONSTRUCTOR_CART_PREVIEW_ALIAS } from '../constants';
import { getVisibleConstructorPages } from './getVisibleConstructorPages';

export const useVisibleConstructorPages = (pages: Page[]): Page[] => {
    const isCartPreviewEnabled = useExperimentCartPreview();
    const isRefundsEnabled = useExperimentFlag('refund_button_b2c', 'exp');

    /**
     * Добавляйте в массив `blacklist` алиасы согласно вашим фичетогглам
     *
     * @example
     * if (isCartPreviewEnabled) {
     *     blacklist.push(CONSTRUCTOR_CART_PREVIEW_ALIAS);
     * }
     */
    const blacklist = [];

    if (!isCartPreviewEnabled) {
        blacklist.push(CONSTRUCTOR_CART_PREVIEW_ALIAS);
    }

    if (!isRefundsEnabled) {
        blacklist.push(CONSTRUCTOR_ACCOUNT_REFUNDS_ALIAS);
    }

    return getVisibleConstructorPages(pages, blacklist);
};
